import request from '@/utils/request'

export async function getData(data) {
  return request({
    url: '/vehicleRegistration/list',
    method: 'post',
    data,
  })
}
export async function getDetail(data) {
  return request({
    url: '/vehicleRegistration/detail',
    method: 'get',
    params: data,
  })
}
export async function searchData(data) {
  return request({
    url: '/vehicleRegistration/get',
    method: 'post',
    data,
  })
}
export async function createData(data) {
  return request({
    url: '/vehicleRegistration/save',
    method: 'post',
    data,
  })
}
export async function updateData(data) {
  return request({
    url: '/vehicleRegistration/edit',
    method: 'post',
    data,
  })
}
export async function pushData(data) {
  return request({
    url: '/vehicleRegistration/push',
    method: 'post',
    data,
  })
}
export async function deleteData(data) {
  return request({
    url: '/vehicleRegistration/delete',
    method: 'post',
    data,
  })
}
export async function revoke(data) {
  return request({
    url: '/vehicleRegistration/revoke',
    method: 'post',
    data,
  })
}
export async function approvalProcess(data) {
  return request({
    url: '/v2/vehicleRegistration/check/process/info',
    method: 'post',
    data,
  })
}
